import pkg from './eventBus';
export default pkg;